export enum SafetySettingCode {
  StopSequenceAllPropspect = 'stop-sequence-all-prospect',
}
